import React, { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomerAuthService from "../services/CustomerAuthServices";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function ResetPassword() {
  const q = useQuery();
  const navigate = useNavigate();

  const token = q.get("token") || "";
  const emailFromUrl = q.get("email") || "";

  const [email, setEmail] = useState(emailFromUrl);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" });

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg({ type: "", text: "" });

    if (!email.trim() || !token) {
      setMsg({ type: "danger", text: "Reset token or email is missing." });
      return;
    }

    if (!password || password.length < 6) {
      setMsg({
        type: "danger",
        text: "Password must be at least 6 characters.",
      });
      return;
    }

    if (password !== confirm) {
      setMsg({ type: "danger", text: "Passwords do not match." });
      return;
    }

    try {
      setLoading(true);

      const res = await CustomerAuthService.resetPassword({
        email: email.trim(),
        token,
        password,
        password_confirmation: confirm,
      });

      setMsg({
        type: "success",
        text: res?.message || "Password reset successful.",
      });

      setTimeout(() => navigate("/login"), 700);
    } catch (err) {
      const apiMsg = err?.response?.data?.message;

      setMsg({
        type: "danger",
        text: apiMsg || "Failed to reset password.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BreadcrumbTwo title="Reset Password" />

      <section className="py-80">
        <div className="container container-lg">
          <div className="row justify-content-center">
            <div className="col-xl-6">
              {msg?.text && (
                <div className={`alert alert-${msg.type || "info"} mb-24`}>
                  {msg.text}
                </div>
              )}

              <div className="border border-gray-100 rounded-16 px-24 py-40">
                <h5 className="mb-16">Create new password</h5>

                <form onSubmit={onSubmit}>
                  <div className="mb-24">
                    <label className="text-neutral-900 text-lg mb-8 fw-medium">
                      Email <span className="text-danger">*</span>
                    </label>

                    <input
                      type="email"
                      className="common-input"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Email"
                    />
                  </div>

                  <div className="mb-24">
                    <label className="text-neutral-900 text-lg mb-8 fw-medium">
                      New Password <span className="text-danger">*</span>
                    </label>

                    <input
                      type="password"
                      className="common-input"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="New password"
                    />
                  </div>

                  <div className="mb-24">
                    <label className="text-neutral-900 text-lg mb-8 fw-medium">
                      Confirm Password <span className="text-danger">*</span>
                    </label>

                    <input
                      type="password"
                      className="common-input"
                      value={confirm}
                      onChange={(e) => setConfirm(e.target.value)}
                      placeholder="Confirm password"
                    />
                  </div>

                  <button
                    disabled={loading}
                    className="btn btn-main py-18 px-40"
                    type="submit"
                  >
                    {loading ? "Saving..." : "Reset password"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}